module.exports = __webpack_public_path__ + "img/tool-just8899.dbc5afc.jpg";